import React from 'react';
import { withRouter } from 'react-router-dom';
import RecoverAccountForm from '../../forms/RecoverAccountForm';

export class RecoverAccountPage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <RecoverAccountForm />
      </div>
    );
  }
}

export default withRouter(RecoverAccountPage);


// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountPage/RecoverAccountPage.jsx